import * as React from "react";
import { useState, createContext, useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../App/store";

export const CounterContext = createContext<{
  counter: number;
  setCounter: React.Dispatch<React.SetStateAction<number>>;
} | null>(null);

export const CounterContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [counter, setCounter] = useState(-1);

  const gameSelector = useSelector((state: RootState) => state.game);

  useEffect(() => {
    let count!: number;
    if (gameSelector.lobby?.counter_end_date) {
      const conterEndDate = new Date(
        gameSelector.lobby.counter_end_date as string
      );
      const diffTime = conterEndDate.getTime() - new Date().getTime();
      count = Math.ceil(diffTime / 1000);
      count = count <= 0 ? -1 : count;
    }
    setTimeout(() => {
      setCounter(count);
    }, 1000);
  }, [gameSelector.joinedLobbyId, gameSelector.lobby, counter]);

  return (
    <CounterContext.Provider
      value={{
        counter,
        setCounter,
      }}
    >
      {children}
    </CounterContext.Provider>
  );
};
